import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const SEARCH_SHIPMENTS_BY_BOOKING_ID_QUERY = gql`
  query SearchShipments($input: SearchShipmentInput!) {
    searchShipments(input: $input) {
      results {
        workOrderGroup {
          workOrders {
            id
            ... on CustomsDeclaration {
              __typename
              goodsShipment {
                importer {
                  id
                }
              }
            }
            ... on UsConsumptionEntry {
              __typename
              ior {
                usIor {
                  importer {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getIorIdByBookingId = async (
  bookingId: string,
): Promise<string | null> => {
  try {
    const { data } = await apolloClient.query({
      query: SEARCH_SHIPMENTS_BY_BOOKING_ID_QUERY,
      variables: {
        input: {
          searchCriteria: {
            bookingId: {
              operator: 'EQUALS',
              values: [bookingId],
            },
          },
        },
      },
    });

    const workOrders =
      data?.searchShipments?.results?.[0]?.workOrderGroup?.workOrders;
    if (!workOrders) return null;

    for (const workOrder of workOrders) {
      if (workOrder.__typename === 'UsConsumptionEntry') {
        return workOrder.ior?.usIor?.importer?.id || null;
      }
      if (workOrder.__typename === 'CustomsDeclaration') {
        return workOrder.goodsShipment?.[0]?.importer?.[0]?.id || null;
      }
    }

    return null;
  } catch (error) {
    console.error(`Failed to get IOR ID for booking ${bookingId}:`, error);
    return null;
  }
};
